import { TabAttemptsFilter, TabAttemptsFilters } from './TabAttemptsFilter';
import { TabAttemptsTable } from './TabAttemptsTable';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';
import type { CrudFilters, HttpError } from '@refinedev/core';
import type { IProfessorAreaEvaluationAttemptList } from 'interfaces/professor_area/evaluations';

export const TabAttempts = () => {
  const params = useParams();
  const classroomId = params.classroomId;
  const evaluationId = params.id;

  const { tableProps, searchFormProps, tableQueryResult } = useTable<
    IProfessorAreaEvaluationAttemptList,
    HttpError,
    TabAttemptsFilters
  >({
    resource: 'professor_area/classroom_assignments/attempts',
    meta: { classroomId, evaluationId },
    onSearch: params => {
      const filters: CrudFilters = [];
      const { by_status, by_user_name } = params;

      filters.push(
        {
          // Backend scope is by_user_name; the old by_title was silently ignored.
          field: 'filter[by_user_name]',
          operator: 'eq',
          value: by_user_name
        },
        {
          field: 'filter[by_status]',
          operator: 'eq',
          value: by_status
        }
      );

      return filters;
    },
    sorters: {
      mode: 'server'
    }
  });

  return (
    <>
      <TabAttemptsFilter searchFormProps={searchFormProps} />
      <TabAttemptsTable
        tableProps={tableProps}
        refetch={tableQueryResult.refetch}
      />
    </>
  );
};
